import { httpCommon, httpTokenFileDownload } from "./interceptor";

class HomeService {
  getAnnouncementsListAPI() {
    return httpCommon.get("system_messages_api/system_messages/");
  }
  //// Download the User Guide
  getDownloadUserGuideAPI() {
    return httpTokenFileDownload.get(`user_guide_api/user_guide/`);
  }
}

const homeService = new HomeService();
export default homeService;
